import {
  getPropDefaultsBase
} from "./chunk-76FQY6HX.js";
import {
  typographyStyles
} from "./chunk-BU6N4DJ3.js";
import {
  select
} from "./chunk-YMNSXZ5D.js";
import {
  applyTypography
} from "./chunk-XBZNPA3L.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-CWMXXUWU.js";

// src/components/typography/base/Display.tsx
import styled from "@emotion/styled";
import { jsx } from "@emotion/react/jsx-runtime";
var displayElements = ["h1", "h2", "h3", "h4", "h5", "h6"];
function DisplayString(props) {
  const _a = getPropDefaults(props), { children } = _a, rest = __objRest(_a, ["children"]);
  return /* @__PURE__ */ jsx(StyledDisplay, __spreadProps(__spreadValues({}, rest), { children }));
}
function getPropDefaults(props) {
  return getPropDefaultsBase(props, { as: props.tag || "h1" });
}
var StyledDisplay = styled.h1`
  ${({ theme, size, colorProp }) => applyTypography(theme, "Display", size, colorProp)}
  ${typographyStyles}
`;
function displaySelector(element) {
  return `${element}${select(StyledDisplay)}`;
}

export {
  displayElements,
  DisplayString,
  getPropDefaults,
  StyledDisplay,
  displaySelector
};
